import { IDashboardOrgInfoData } from '@interfaces/dashboard';

import { apiUrls } from './urls';
import { get } from './utils';

export const getDashboardOrgInfo = () => get<IDashboardOrgInfoData>(apiUrls.dashboard.orgInfo);
